<script>
import RecruitContent from "@/components/career/RecruitContent.vue";

export default {
  name: "Staff03.vue",
  components: {RecruitContent},
  data(){
    return {
      description1: '',
      description2: '',
      heading01: ''
    }
  },
  mounted() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize(){
      const des1 = '電気設備の'
      const des2 = '施工経験を活かして、'
      const all = '電気設備の施工経験を活かして、'
      const headingPc = '設備を長く、\n安全に使い続ける。\n「保全」の重要性に気づき、\nクレハに入社。'
      const headingMb = '設備を長く、安全に使い続ける。\n「保全」の重要性に気づき、\nクレハに入社。'
      if(window.innerWidth >= 900){
        this.description1 = all
        this.description2 = ''
        this.heading01 = headingPc
      }else{
        this.description1 = des1
        this.description2 = des2
        this.heading01 = headingMb
      }
    }
  }
}
</script>

<template>
  <div>
    <recruit-content
        name="田子 博康"
        :office="'いわき事業所\n設備保全部'"
        join-year="2019"
        sort="03"
        :tags="'#電気設備 #生産環境の質向上 \n#スマート保全化'"
        title="設備保全"
        :description01="description1"
        :description02="description2"
        description03="事業所のスマート保全化に挑む。"
        :banner="require('@/assets/img/career/04/hero.jpg')"
        :banner-sp="require('@/assets/img/career/04/hero-sp.jpg')"
        :answer-heading01="heading01"
        :answer-image01="require('@/assets/img/career/04/image-01.jpg')"
        answer-paragraph01="電気設備工事の施工管理を行っていた私が保全に興味を持ち始めたのは、改修工事中のとある発見からでした。それは、長く使うことを考えて設備が運用されていないということです。もう少し工夫して運用すれば、劣化速度を遅らせることができたかもしれないのに、と思うことがしばしばあり、設備を長く使い続けるための点検や整備の重要性を意識するようになりました。しかしながら、設備を組み立てる技術と、長寿命化させる技術は考え方がまったく異なります。後者の技術やスキルを学びたいと考え、企業の保全部を中心に転職活動を始めました。クレハへの入社の決め手は、「まず自分たちでやってみる」という前向きな姿勢に感銘を受けたからです。前職での経験上、メーカーの保全部の多くは、外部の設備会社に業務を委託することがほとんどでした。一方で、クレハの保全部は、トラブル対応から予防保全まで、自分たちの力でなんとかしていこうという風土がありました。外注していない分、意思決定のスピードが早く、保全に関する知識やノウハウも豊富に蓄積されている。保全の経験を積むなら、この環境しかないと思ったんです。"
        :answer-heading02="'電気設備の保全技術を磨き、\n生産環境の効率化と\n長寿命化を叶える。'"
        :answer-image02="require('@/assets/img/career/04/image-02.jpg')"
        answer-paragraph02="NEWクレラップの原料などの合成樹脂製造プラントと、医薬品製造プラント、事務所や寮などの保全を担当しています。電気設備のトラブル対応と予防保全が主な仕事です。予防保全業務では、測定器の数値から設備寿命を計算し、寿命が短いものは部品を交換するなど、少しでも長く設備を使い続けるための措置を施します。前職と比較してギャップを感じるのは、化学の専門知識を必要とする場面が多いこと。例えば、化学薬品を使用する設備に測定機を設置する時、機器に薬品が触れることで故障に繋がるリスクが高まる恐れがあるため、細心の注意を払わなければなりません。これまで電気工学の分野しか触れてこなかったので、化学の知識が足りないと感じることもありますが、社内で行われている化学に関する勉強会に参加するなど、インプットにも力を入れて、スキルアップしています。また、事業所設備のスマート保全化も、私たち保全部に課せられた重要なミッションです。現場に行かずとも、PC画面上で測定値を管理できるようにするなど、保全業務の効率化を目指しています。この取り組みは、クレハとしても新たな挑戦の一つです。最新のデジタル技術も取り入れながら、最適な施策を探っています。このように、設備のトラブル対応にとどまらず、よりよい生産環境を自分たちの手で作っていけることが、クレハの保全部で働く魅力だと思います。"
        answer-paragraph03="通常の保全業務はもちろん、現在進行中のスマート保全化に今後も力を入れていきたいと考えています。最新のDX技術を取り入れるなど様々な取り組みを行っているものの、事業所設備の管理体制にはまだまだ課題が多くあります。例えば、広大ないわき事業所には48もの変電所があるのですが、変電設備の部品は、それぞれの変電所ごとに管理しています。そのため設備トラブルなどで部品交換が必要になった際、その部品の在庫を各変電所に確認して回らなければならないのです。もし各設備の使用部品やその在庫数、管理場所がシステムで分かるようになれば、保全業務の効率化に大きく貢献できます。手探りなことも多いですが、前例がない分、様々な技術分野にチャレンジできることにやりがいを感じています。保全部としてここまで自由に挑戦させてもらえるのは、クレハならではの風土だと思います。「保全」と聞くと、保守点検といった縁の下の力持ちのような役割を想像しがちですが、クレハの保全は主体性を持って、生産環境の質を向上する取り組みにチャレンジできます。自分たちでは限界のある部分は、外部の設備会社に協力を仰ぎ、社内外から新しい知見を吸収しながら、電気設備保全のプロとして専門性を磨いていければと思っています。"
        :answer-heading03="'事業所のスマート保全化に向け、\n最新技術を積極的に取り入れていく。'"
        :answer-image03="require('@/assets/img/career/04/image-04.jpg')"
        :banner-full="require('@/assets/img/career/04/image-03.jpg')"
        :banner-full-sp="require('@/assets/img/career/04/image-03-sp.jpg')"
        class-custom="staff03"
    />
  </div>
</template>

<style lang="scss">
.staff04{
& > .hero-banner{
  @media print, screen and (max-width: 900px) {
    padding-bottom: 90px;
  }
  & > .title{
    & > div{
      &:first-child{
        @media print, screen and (max-width: 900px) {
          top: -2.7%;
        }

        @media print, screen and (max-width: 456px) {
          top: 0.8%;
        }
        & > p{
          & > span{
            &:last-child{
              @media print, screen and (max-width: 456px) {
                white-space: pre !important;
                height: 64px;
              }
            }
          }
        }
      }
    }
    &:last-child{
      @media print, screen and (max-width: 900px) {
        bottom: 1%;
      }
    }

    & > div{
      &:last-child{
        margin-left: 12px;
        @media print, screen and (max-width: 900px) {margin-left: 0;}
      }
    }
  }

  & > .image{
    & > picture{
       & > img {
        @media print, screen and (max-width: 900px) {
          object-position: right;
        }
       }
    }
  }
}
}
</style>
